export const sequences2029 = [
  ['are', 'real', 'large', 'larger'],
  ['ear', 'race', 'reach', 'charge'],
  ['tea', 'heat', 'cheat', 'chalet'],
  ['eat', 'heat', 'heart', 'father'],
  ['ate', 'date', 'rated', 'thread'],
  ['are', 'rate', 'stare', 'master'],
  ['ear', 'rate', 'later', 'travel'],
  ['tea', 'east', 'state', 'latest'],
  ['eat', 'tale', 'stale', 'salute'],
  ['ate', 'heat', 'theta', 'threat'],
  ['are', 'rate', 'eater', 'repeat'],
  ['ear', 'tear', 'react', 'racket'],
  ['tea', 'late', 'slate', 'stable'],
  ['eat', 'date', 'acted', 'traced'],
  ['ate', 'seat', 'caste', 'stance'],
  ['are', 'bear', 'zebra', 'blazer'],
  ['ear', 'hear', 'share', 'search'],
  ['tea', 'seat', 'tease', 'seated'],
  ['eat', 'rate', 'rated', 'traced'],
  ['ate', 'east', 'steal', 'stella'],
  ['are', 'tear', 'crate', 'create'],
  ['ear', 'gear', 'grave', 'gravel'],
  ['tea', 'seat', 'stare', 'master'],
  ['eat', 'east', 'paste', 'staple'],
  ['ate', 'date', 'tamed', 'teamed'],
  ['are', 'tear', 'trace', 'carpet'],
  ['ear', 'care', 'grace', 'charge'],
  ['tea', 'late', 'table', 'battle'],
  ['eat', 'tale', 'steal', 'latest'],
  ['ate', 'rate', 'trace', 'create'],
  ['are', 'race', 'reach', 'charge'],
  ['ear', 'rate', 'terra', 'arrest'],
  ['tea', 'mate', 'steam', 'steamy'],
  ['eat', 'date', 'delta', 'talked'],
  ['ate', 'east', 'slate', 'castle'],
  ['are', 'fear', 'freak', 'freaky'],
  ['ear', 'tear', 'after', 'fatter'],
  ['tea', 'late', 'later', 'travel'],
  ['eat', 'tale', 'fetal', 'falter'],
  ['ate', 'meat', 'mater', 'market'],
  ['are', 'race', 'crate', 'carpet'],
  ['ear', 'earl', 'laser', 'serial'],
  ['tea', 'date', 'dealt', 'detail'],
  ['eat', 'mate', 'mater', 'master'],
  ['ate', 'tear', 'grate', 'garnet'],
  ['are', 'dare', 'bread', 'barred'],
  ['ear', 'earn', 'crane', 'dancer'],
  ['tea', 'tale', 'stale', 'salute'],
  ['eat', 'neat', 'taken', 'tanker'],
  ['ate', 'seat', 'taste', 'statue'],
  ['are', 'gear', 'graze', 'grazed'],
  ['ear', 'real', 'flare', 'raffle'],
  ['tea', 'mate', 'mater', 'master'],
  ['eat', 'mate', 'meant', 'magnet'],
  ['ate', 'heat', 'heath', 'health'],
  ['are', 'rage', 'grate', 'triage'],
  ['ear', 'dare', 'adore', 'reload'],
  ['tea', 'seat', 'asset', 'safest'],
  ['eat', 'date', 'trade', 'hatred'],
  ['ate', 'rate', 'great', 'gather'],
  ['are', 'gear', 'grave', 'gravel'],
  ['ear', 'rear', 'racer', 'archer'],
  ['tea', 'east', 'tesla', 'salute'],
  ['eat', 'tear', 'water', 'wreath'],
  ['ate', 'heat', 'wheat', 'wealth'],
  ['are', 'rage', 'marge', 'german'],
  ['ear', 'dare', 'dared', 'adored'],
  ['tea', 'heat', 'wheat', 'wealth'],
  ['eat', 'take', 'stake', 'basket'],
  ['ate', 'rate', 'later', 'travel'],
  ['are', 'gear', 'argue', 'argued'],
  ['ear', 'tear', 'alter', 'taller'],
  ['tea', 'date', 'taped', 'update'],
  ['eat', 'tale', 'tesla', 'stella'],
  ['ate', 'tear', 'after', 'fatter'],
  ['sec', 'case', 'cause', 'caused'],
  ['age', 'rage', 'great', 'garret'],
  ['ten', 'tone', 'tenor', 'orient'],
  ['sin', 'spin', 'spine', 'sniper'],
  ['yet', 'type', 'petty', 'pretty'],
  ['set', 'nest', 'tense', 'resent'],
  ['nor', 'iron', 'minor', 'inform'],
  ['ole', 'role', 'older', 'louder'],
  ['and', 'dean', 'sedan', 'ascend'],
  ['let', 'tale', 'stale', 'lasted'],
  ['out', 'thou', 'tough', 'though'],
  ['ago', 'goal', 'along', 'slogan'],
  ['one', 'gone', 'gnome', 'genome'],
  ['lie', 'live', 'liver', 'silver'],
  ['sea', 'seat', 'yeast', 'safety'],
  ['pay', 'pray', 'repay', 'player'],
  ['lip', 'slip', 'spoil', 'polish'],
  ['sat', 'last', 'steal', 'latest'],
  ['aim', 'mail', 'email', 'amelia'],
  ['lab', 'able', 'bagel', 'beagle'],
  ['fit', 'lift', 'flirt', 'filter'],
  ['mac', 'came', 'camel', 'marcel'],
  ['ole', 'mole', 'melon', 'molten'],
  ['red', 'rude', 'ruled', 'louder'],
  ['art', 'star', 'trash', 'thrash'],
  ['not', 'note', 'noted', 'donate'],
  ['cap', 'pace', 'peach', 'chapel'],
  ['oil', 'soil', 'solid', 'soiled'],
  ['net', 'neat', 'taken', 'intake'],
  ['ten', 'nest', 'stein', 'silent'],
  ['pal', 'lamp', 'maple', 'palmer'],
  ['run', 'ruin', 'urine', 'ruined'],
  ['sea', 'east', 'steak', 'staked'],
  ['let', 'late', 'later', 'travel'],
  ['lab', 'lamb', 'blame', 'blamed'],
  ['ain', 'nail', 'slain', 'island'],
  ['not', 'into', 'tonic', 'action'],
  ['sea', 'east', 'skate', 'streak'],
  ['bar', 'brad', 'broad', 'abroad'],
  ['let', 'late', 'steal', 'latest'],
  ['man', 'amen', 'named', 'medina'],
  ['lad', 'dial', 'ideal', 'sailed'],
  ['and', 'dean', 'dance', 'dancer'],
  ['car', 'care', 'recap', 'preach'],
  ['pro', 'poor', 'troop', 'pronto'],
  ['rat', 'rate', 'water', 'waiter'],
  ['sad', 'said', 'aside', 'raised'],
  ['rid', 'bird', 'rabid', 'bridal'],
  ['fed', 'fled', 'field', 'failed'],
  ['hat', 'heat', 'earth', 'rather'],
  ['rat', 'tear', 'mater', 'matter'],
  ['his', 'this', 'sight', 'slight'],
  ['red', 'dare', 'grade', 'garden'],
  ['log', 'goal', 'along', 'gallon'],
  ['ace', 'each', 'cheap', 'chapel'],
  ['one', 'done', 'noted', 'donate'],
  ['act', 'chat', 'chant', 'snatch'],
  ['cat', 'cast', 'coast', 'castor'],
  ['ale', 'meal', 'realm', 'marcel'],
  ['old', 'doll', 'dolly', 'loudly'],
  ['ran', 'darn', 'randy', 'brandy'],
  ['let', 'late', 'plate', 'planet'],
  ['aid', 'raid', 'drain', 'daring'],
  ['hot', 'shot', 'shoot', 'smooth'],
  ['hat', 'chat', 'catch', 'catchy'],
  ['ran', 'barn', 'brain', 'brainy'],
  ['all', 'ally', 'sally', 'lastly'],
  ['set', 'seat', 'steal', 'stable'],
  ['rat', 'rate', 'earth', 'breath'],
  ['hot', 'both', 'broth', 'bother'],
  ['bad', 'band', 'brand', 'brandy'],
  ['don', 'dong', 'doing', 'coding'],
  ['end', 'dean', 'dance', 'dancer'],
  ['pit', 'spit', 'strip', 'priest'],
  ['age', 'game', 'image', 'mirage'],
  ['cat', 'cart', 'track', 'racket'],
  ['ole', 'role', 'lower', 'flower'],
  ['mad', 'maid', 'media', 'admire'],
  ['sat', 'east', 'steak', 'casket'],
  ['see', 'ease', 'erase', 'easier'],
  ['men', 'mean', 'meant', 'mental'],
  ['aid', 'idea', 'ideal', 'failed'],
  ['ice', 'nice', 'niece', 'entice'],
  ['hat', 'than', 'haunt', 'naught'],
  ['see', 'seed', 'steed', 'desert'],
  ['red', 'dare', 'trade', 'thread'],
  ['sea', 'seat', 'feast', 'faster'],
  ['one', 'nose', 'noise', 'senior'],
  ['car', 'race', 'scare', 'sacred'],
  ['see', 'else', 'steel', 'settle'],
  ['rid', 'ride', 'diner', 'dinner'],
  ['ten', 'note', 'tenor', 'rotten'],
  ['led', 'lend', 'lined', 'linked'],
  ['one', 'note', 'monte', 'moment'],
  ['bar', 'bear', 'brave', 'beaver'],
  ['rid', 'ride', 'fried', 'fridge'],
  ['ace', 'each', 'cheat', 'chalet'],
  ['sue', 'sure', 'purse', 'pursue'],
  ['let', 'tale', 'dealt', 'detail'],
  ['rat', 'rate', 'crate', 'carpet'],
  ['ten', 'tend', 'noted', 'stoned'],
  ['ace', 'care', 'brace', 'breach'],
  ['one', 'nose', 'senor', 'person'],
  ['our', 'hour', 'rough', 'trough'],
  ['sea', 'seat', 'steal', 'latest'],
  ['met', 'team', 'metal', 'hamlet'],
  ['sit', 'site', 'stein', 'listen'],
  ['aye', 'year', 'relay', 'nearly'],
  ['red', 'ride', 'wired', 'wilder'],
  ['pan', 'pain', 'plain', 'alpine'],
  ['dig', 'ding', 'doing', 'coding'],
  ['pal', 'plan', 'plain', 'spinal'],
  ['met', 'meat', 'steam', 'steamy'],
  ['bed', 'bend', 'blend', 'blonde'],
  ['net', 'tone', 'noted', 'rodent'],
  ['rid', 'ride', 'wider', 'rewind'],
  ['tag', 'gate', 'grate', 'gather'],
  ['led', 'fled', 'filed', 'failed'],
  ['man', 'many', 'manly', 'mainly'],
  ['day', 'lady', 'daily', 'milady'],
  ['dry', 'yard', 'ready', 'prayed'],
  ['she', 'shoe', 'house', 'housed'],
  ['sin', 'sign', 'using', 'genius'],
  ['row', 'worn', 'grown', 'rowing'],
  ['sir', 'sire', 'raise', 'raised'],
  ['net', 'sent', 'scent', 'nicest'],
  ['set', 'east', 'feast', 'safety'],
  ['war', 'warn', 'drawn', 'warden'],
  ['due', 'dude', 'duped', 'dumped'],
  ['hat', 'heat', 'haste', 'hasten'],
  ['ace', 'care', 'crate', 'carpet'],
  ['sea', 'east', 'caste', 'chaste'],
  ['age', 'rage', 'marge', 'manger'],
  ['hop', 'chop', 'pooch', 'poncho'],
  ['ain', 'pain', 'plain', 'spinal'],
  ['pan', 'pain', 'paint', 'taping'],
  ['sat', 'seat', 'steal', 'castle'],
  ['air', 'fair', 'fairy', 'fairly'],
  ['and', 'darn', 'drawn', 'warden'],
  ['hat', 'halt', 'latch', 'chalet'],
  ['art', 'tear', 'grate', 'garret'],
  ['and', 'dean', 'sedan', 'ascend'],
  ['act', 'chat', 'chart', 'starch'],
  ['aid', 'paid', 'rapid', 'diaper'],
  ['ran', 'barn', 'baron', 'carbon'],
  ['sat', 'salt', 'least', 'stella'],
  ['car', 'race', 'cedar', 'scared'],
  ['one', 'done', 'demon', 'modern'],
  ['lie', 'live', 'lived', 'drivel'],
  ['men', 'name', 'meant', 'magnet'],
  ['and', 'darn', 'drawn', 'warden'],
  ['nor', 'horn', 'north', 'thrown'],
  ['con', 'once', 'coven', 'convey'],
  ['son', 'nose', 'snore', 'reason'],
  ['bat', 'stab', 'beast', 'basket'],
  ['fun', 'fund', 'found', 'unfold'],
  ['hit', 'this', 'sight', 'slight'],
  ['sea', 'safe', 'false', 'safely'],
  ['bad', 'brad', 'bread', 'badger'],
  ['led', 'lead', 'laced', 'candle'],
  ['ben', 'bend', 'blend', 'blonde'],
  ['ice', 'eric', 'crime', 'metric'],
  ['ten', 'then', 'thine', 'ethnic'],
  ['aye', 'year', 'layer', 'lawyer'],
  ['sea', 'east', 'haste', 'hasten'],
  ['ace', 'race', 'raced', 'cradle'],
  ['ran', 'earn', 'learn', 'learnt'],
  ['red', 'ride', 'tired', 'direct'],
  ['one', 'once', 'canoe', 'deacon'],
  ['art', 'rate', 'treat', 'matter'],
  ['lab', 'able', 'cable', 'bleach'],
  ['hat', 'heat', 'theta', 'hatter'],
  ['bus', 'bust', 'burst', 'buster'],
  ['bar', 'barn', 'brain', 'binary'],
  ['and', 'darn', 'randy', 'brandy'],
  ['now', 'worn', 'wrong', 'rowing'],
  ['sat', 'salt', 'slate', 'latest'],
  ['all', 'tall', 'tally', 'lately'],
  ['sea', 'sake', 'steak', 'basket'],
  ['not', 'torn', 'tenor', 'mentor'],
  ['nah', 'than', 'haunt', 'naught'],
  ['bet', 'tube', 'brute', 'butler'],
  ['lap', 'palm', 'ample', 'palmer'],
  ['sea', 'sale', 'aisle', 'easily'],
  ['pet', 'step', 'spite', 'priest'],
  ['bar', 'bear', 'saber', 'breast'],
  ['ray', 'year', 'relay', 'nearly'],
  ['ace', 'care', 'scare', 'scared'],
  ['sea', 'seal', 'laser', 'slater'],
  ['sat', 'past', 'strap', 'pastor'],
  ['art', 'rate', 'heart', 'rather'],
  ['lie', 'lied', 'lined', 'nailed'],
  ['ale', 'meal', 'blame', 'blamed'],
  ['top', 'stop', 'sport', 'pastor'],
  ['sat', 'seat', 'stale', 'lasted'],
  ['led', 'lied', 'riled', 'riddle'],
  ['lad', 'dale', 'plead', 'paddle'],
  ['lie', 'lied', 'slide', 'shield'],
  ['set', 'nest', 'stein', 'finest'],
  ['sat', 'cast', 'costa', 'castor'],
  ['car', 'care', 'trace', 'create'],
  ['her', 'hear', 'rehab', 'breath'],
  ['wad', 'dawn', 'drawn', 'warned'],
  ['nut', 'unit', 'unity', 'mutiny'],
  ['mad', 'maid', 'aimed', 'maiden'],
  ['can', 'clan', 'lance', 'candle'],
  ['not', 'into', 'intro', 'ration'],
  ['lad', 'dale', 'blade', 'doable'],
  ['nut', 'tune', 'untie', 'united'],
  ['tap', 'tape', 'taped', 'update'],
  ['pet', 'tape', 'taped', 'update'],
  ['one', 'zone', 'ozone', 'snooze'],
  ['age', 'gave', 'vegan', 'avenge'],
  ['sin', 'sign', 'sling', 'single'],
  ['act', 'cast', 'caste', 'castle'],
  ['now', 'worn', 'owner', 'wonder'],
  ['won', 'worn', 'wrong', 'rowing'],
  ['set', 'seat', 'asset', 'safest'],
  ['lie', 'mile', 'slime', 'smiled'],
  ['don', 'done', 'drone', 'wonder'],
  ['had', 'hard', 'hardy', 'hardly'],
  ['ask', 'sake', 'stake', 'basket'],
  ['sea', 'same', 'means', 'seaman'],
  ['sat', 'cast', 'caste', 'castle'],
  ['let', 'tell', 'telly', 'lately'],
  ['car', 'care', 'cedar', 'dancer'],
  ['hot', 'host', 'shoot', 'soothe'],
  ['end', 'lend', 'lined', 'linked'],
  ['pro', 'rope', 'prone', 'person'],
  ['one', 'tone', 'tenor', 'throne'],
  ['win', 'wing', 'swing', 'sewing'],
  ['rat', 'rate', 'extra', 'baxter'],
  ['per', 'prey', 'repay', 'prayed'],
  ['sat', 'east', 'feast', 'safest'],
  ['car', 'care', 'raced', 'traced'],
  ['bad', 'bald', 'blade', 'blamed'],
  ['air', 'raid', 'radio', 'hairdo'],
  ['lad', 'dale', 'dealt', 'detail'],
  ['win', 'wing', 'owing', 'owning'],
  ['bet', 'best', 'beast', 'stable'],
  ['cut', 'cute', 'truce', 'tucker'],
  ['con', 'coin', 'chino', 'chopin'],
  ['fed', 'feed', 'freed', 'feared'],
  ['sat', 'seat', 'steam', 'master'],
  ['bar', 'bear', 'barge', 'beggar'],
  ['sit', 'suit', 'suite', 'tissue'],
  ['bow', 'blow', 'below', 'bowler'],
  ['let', 'tale', 'slate', 'stella'],
  ['ran', 'rang', 'grant', 'rating'],
  ['ten', 'tune', 'tuned', 'turned'],
  ['art', 'tear', 'stare', 'breast'],
  ['hat', 'heat', 'heath', 'health'],
  ['sea', 'sake', 'stake', 'streak'],
  ['lee', 'else', 'sleet', 'select'],
  ['net', 'rent', 'brent', 'banter'],
  ['sir', 'rise', 'rinse', 'resign'],
  ['may', 'many', 'manly', 'mainly'],
  ['ten', 'rent', 'stern', 'insert'],
  ['act', 'cart', 'actor', 'carrot'],
  ['ran', 'earn', 'anger', 'danger'],
  ['ray', 'year', 'weary', 'sawyer'],
  ['arm', 'mark', 'maker', 'market'],
  ['bar', 'brad', 'beard', 'badger'],
  ['red', 'dare', 'adore', 'reload'],
  ['ran', 'rain', 'brain', 'binary'],
  ['kid', 'kind', 'drink', 'kinder'],
  ['map', 'camp', 'cramp', 'camper'],
  ['end', 'send', 'denis', 'inside'],
  ['aid', 'dial', 'laird', 'bridal'],
  ['bar', 'brad', 'board', 'aboard'],
  ['lad', 'deal', 'laden', 'handle'],
  ['age', 'rage', 'barge', 'badger'],
  ['con', 'coin', 'sonic', 'cousin'],
  ['hat', 'than', 'chant', 'snatch'],
  ['net', 'nest', 'tense', 'resent'],
  ['hot', 'host', 'ghost', 'sought'],
  ['lab', 'able', 'blade', 'blamed'],
  ['set', 'east', 'slate', 'stable'],
  ['bad', 'brad', 'broad', 'abroad'],
  ['ace', 'pace', 'peace', 'escape'],
  ['sat', 'seat', 'steak', 'streak'],
  ['boo', 'boom', 'broom', 'boomer'],
  ['sit', 'this', 'shift', 'fetish'],
  ['ran', 'rank', 'crank', 'cranky'],
  ['and', 'land', 'laden', 'handle'],
  ['sec', 'case', 'chase', 'search'],
  ['art', 'star', 'roast', 'pastor'],
  ['red', 'ride', 'wider', 'rewind'],
  ['bad', 'brad', 'beard', 'barbed'],
  ['but', 'tube', 'brute', 'butler'],
];